<script setup lang="ts">
import { useSupplierPreferencesStore } from '../stores/supplierPreferences'

const props = defineProps<{
    supplierId: string
    compact?: boolean
}>()

const prefsStore = useSupplierPreferencesStore()
</script>

<template>
    <div class="flex items-center" :class="compact ? 'gap-1' : 'gap-2'">
        <!-- Favorite -->
        <button
            @click.stop="prefsStore.toggleFavorite(props.supplierId)"
            :title="prefsStore.isFavorite(props.supplierId) ? 'Remove from favorites' : 'Add to favorites'"
            class="transition-all rounded-md focus:outline-none focus:ring-2 focus:ring-yellow-400"
            :class="[
                compact ? 'p-1' : 'p-1.5',
                prefsStore.isFavorite(props.supplierId)
                    ? 'text-yellow-500 bg-yellow-50 dark:bg-yellow-900/30 hover:text-yellow-600'
                    : 'text-gray-500 dark:text-gray-300 bg-gray-100 dark:bg-gray-700 hover:text-yellow-500 hover:bg-yellow-50 dark:hover:bg-yellow-900/30'
            ]"
        >
            <svg :class="compact ? 'w-4 h-4' : 'w-5 h-5'" :fill="prefsStore.isFavorite(props.supplierId) ? 'currentColor' : 'none'" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z"/>
            </svg>
        </button>

        <!-- Direct Contract -->
        <button
            @click.stop="prefsStore.toggleDirectContract(props.supplierId)"
            :title="prefsStore.isDirectContract(props.supplierId) ? 'Remove direct contract' : 'Mark as direct contract'"
            class="transition-all rounded-md focus:outline-none focus:ring-2 focus:ring-blue-400"
            :class="[
                compact ? 'p-1' : 'p-1.5',
                prefsStore.isDirectContract(props.supplierId)
                    ? 'text-blue-500 bg-blue-50 dark:bg-blue-900/30 hover:text-blue-600'
                    : 'text-gray-500 dark:text-gray-300 bg-gray-100 dark:bg-gray-700 hover:text-blue-500 hover:bg-blue-50 dark:hover:bg-blue-900/30'
            ]"
        >
            <svg :class="compact ? 'w-4 h-4' : 'w-5 h-5'" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"/>
            </svg>
        </button>

        <!-- Block -->
        <button
            @click.stop="prefsStore.toggleBlocked(props.supplierId)"
            :title="prefsStore.isBlocked(props.supplierId) ? 'Unblock supplier' : 'Block supplier'"
            class="transition-all rounded-md focus:outline-none focus:ring-2 focus:ring-red-400"
            :class="[
                compact ? 'p-1' : 'p-1.5',
                prefsStore.isBlocked(props.supplierId)
                    ? 'text-red-500 bg-red-50 dark:bg-red-900/30 hover:text-red-600'
                    : 'text-gray-500 dark:text-gray-300 bg-gray-100 dark:bg-gray-700 hover:text-red-500 hover:bg-red-50 dark:hover:bg-red-900/30'
            ]"
        >
            <svg :class="compact ? 'w-4 h-4' : 'w-5 h-5'" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636"/>
            </svg>
        </button>
    </div>
</template>
